import { BACKEND_PORT, HTTP_PROTOCOL, SERVER_HOST } from 'ev-config/config';

/** Backend endpoint is named after pusher but it handles both Pusher and AnyCable */
const AUTH_ENDPOINT = '/r-static/proxy/api/v4/pusher/auth';

/**
 * Fetch JWT for Action Cable connection. Calls same auth endpoint as Pusher;
 * when practice uses Anycable, response includes { token, backend: 'anycable' }.
 */
export async function fetchAnycableToken(
  channelName: string,
  authToken: string | undefined,
): Promise<string | null> {
  const socketId = `actioncable-${Date.now()}`;
  const proxyHost = `${HTTP_PROTOCOL}://${SERVER_HOST}:${BACKEND_PORT}`;

  const form = new URLSearchParams();
  form.set('channel_name', channelName);
  form.set('socket_id', socketId);

  const headers: Record<string, string> = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Target-Host': proxyHost,
  };
  if (authToken) {
    headers['Secure-Authentication-Token'] = authToken;
  }

  const response = await fetch(AUTH_ENDPOINT, {
    method: 'POST',
    headers,
    body: form.toString(),
  });

  if (!response.ok) {
    return null;
  }

  const json = (await response.json()) as { token?: string; backend?: string };
  if (json.backend !== 'anycable' || !json.token) {
    return null;
  }

  return json.token;
}
